import React from "react";
import { Card, Col, Container, Row, Button } from "react-bootstrap";
import { FileEarmarkText } from "react-bootstrap-icons";
import "./Navbar.css";
import "bootstrap/dist/css/bootstrap.min.css";

interface DocumentItem {
    title: string;
    description: string;
    url: string;
}

const documents: DocumentItem[] = [
    {
        title: "PAIA Manual",
        description: "",
        url: "/Documents/PAIAManual.pdf",
    },
    {
        title: "Conflict of Interest Policy",
        description: "",
        url: "/Documents/ConflictOfInterestManagementPolicy.pdf",
    },
    {
        title: "Complaints Handling Procedure",
        description: "",
        url: "/Documents/ComplaintProcess.pdf",
    },
];

const LegalInformation: React.FC = () => {
    return (
        <>
            <Container
                fluid
                style={{
                    background: "linear-gradient(135deg, #1e1e3f 0%, #3a275e 50%, #ffcc00 100%)",
                    color: "#ffffff",
                    padding: "4rem 2rem",
                    position: "relative",
                    textAlign: "center",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                        zIndex: 1,
                    }}
                />
                <div style={{ position: "relative", zIndex: 2 }}>
                    <h1 style={{ fontSize: "3rem", fontWeight: 700, marginBottom: "1rem" }}>
                        Legal Information
                    </h1>
                    <p style={{ fontSize: "1.25rem", maxWidth: "700px", margin: "0 auto", color: "#f0f0f0" }}>
                        Access important legal and compliance documents below.
                    </p>
                </div>
            </Container>

            <Container className="my-5">
                <Row className="g-4">
                    {documents.map((doc, idx) => (
                        <Col md={6} lg={4} key={idx}>
                            <Card
                                style={{
                                    borderRadius: "15px",
                                    boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.1)",
                                    padding: "1.5rem",
                                    height: "100%",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                    (e.currentTarget as HTMLDivElement).style.transform = "translateY(-5px)";
                                    (e.currentTarget as HTMLDivElement).style.boxShadow = "0 12px 30px rgba(0, 0, 0, 0.15)";
                                }}
                                onMouseLeave={(e) => {
                                    (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)";
                                    (e.currentTarget as HTMLDivElement).style.boxShadow = "0px 6px 20px rgba(0, 0, 0, 0.1)";
                                }}
                            >
                                <Card.Body className="text-center">
                                    <FileEarmarkText size={48} className="mb-3 text-primary" />
                                    <Card.Title style={{ fontWeight: 600, fontSize: "1.25rem" }}>
                                        {doc.title}
                                    </Card.Title>
                                    <Card.Text style={{ fontSize: "0.95rem", color: "#555" }}>
                                        {doc.description}
                                    </Card.Text>
                                    <a
                                        href={doc.url}
                                        download
                                        className="btn btn-outline-primary"
                                        style={{ marginTop: "1rem", display: "inline-block" }}
                                    >
                                        Download PDF
                                    </a>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </>
    );
};

export default LegalInformation;
